import { BooleanInput, maxLength, maxValue, minValue, NumberInput, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionBg"
          label="Описание (БГ)"
          fullWidth
          validate={[required(), maxLength(255)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionEn"
          label="Описание (EN)"
          fullWidth
          validate={[required(), maxLength(255)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="quadrature"
          label="Квадратура"
          fullWidth
          validate={[required(), minValue(0.01)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="capacity"
          label="Брой места"
          fullWidth
          validate={[required(), minValue(1)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="roomRental"
          label="Наем за цялата стая"
          fullWidth
          validate={[required(), minValue(0)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="costPerPerson"
          label="Наем на човек"
          fullWidth
          validate={[required(), minValue(0)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="discountChild"
          label="Отстъпка за едно дете (%)"
          fullWidth
          validate={[required(), minValue(0), maxValue(100)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="discountChildren"
          label="Отстъпка за две и повече деца (%)"
          fullWidth
          validate={[required(), minValue(0), maxValue(100)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <BooleanInput
          source="terrace"
          label="Тераса"
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <BooleanInput
          source="suitableForFamily"
          label="Подходяща за семейство с деца"
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <BooleanInput
          source="suitableForDisabled"
          label="Подходяща за хора с увреждания"
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
